import { render, staticRenderFns } from "./MeatFishStep.vue?vue&type=template&id=c38874b0&"
import script from "./MeatFishStep.vue?vue&type=script&lang=js&"
export * from "./MeatFishStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports